// extracted by mini-css-extract-plugin
module.exports = {"threeDSWrapper":"style_threeDSWrapper___K_R3","threeDSIframe":"style_threeDSIframe__39ugA","close":"style_close__ECiZM"};